// extracted by mini-css-extract-plugin
export var colorSquare = "_o3-0";
export var danger = "_o3-5";
export var lightPink = "_o3-8";
export var neutralBlue = "_o3-7";
export var neutralYellow = "_o3-6";
export var normal = "_o3-1";
export var primary = "_o3-2";
export var primaryLight = "_o3-3";
export var solidBlack = "_o3-g";
export var solidGreen = "_o3-b";
export var solidLightBlue = "_o3-d";
export var solidNavy = "_o3-c";
export var solidOrange = "_o3-f";
export var solidPink = "_o3-e";
export var solidRed = "_o3-9";
export var solidYellow = "_o3-a";
export var success = "_o3-4";